import { IconButton, ListItemIcon, Menu, MenuItem, Typography } from '@mui/material';
import { VyIcon } from '@weft/icons';
import { useMenu } from 'apps/app/src/hooks/use-menu';
import React from 'react';

type DynamicActionMenuProps = {
  itemId: string;
  disabled: boolean;
  onEdit?: () => void;
  onDelete: (id: string) => void;
};

export const DynamicActionMenu: React.FC<DynamicActionMenuProps> = ({ itemId, disabled, onEdit, onDelete }) => {
  const { anchorElement, isOpen, handleMenuOpen, handleMenuClose } = useMenu();

  const handleAction = (actionFn?: () => void) => {
    handleMenuClose();
    actionFn?.();
  };

  return (
    <div>
      <IconButton
        size="medium"
        onClick={handleMenuOpen}
        disabled={disabled}
      >
        <VyIcon
          icon="DotsMenu"
          style={{ transform: 'rotate(90deg)' }}
        />
      </IconButton>

      <Menu
        anchorEl={anchorElement}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
        transformOrigin={{ vertical: 'top', horizontal: 'right' }}
        open={isOpen}
        onClose={handleMenuClose}
      >
        <MenuItem onClick={() => handleAction(onEdit)}>
          <ListItemIcon>
            <VyIcon icon="Edit" />
          </ListItemIcon>
          <Typography
            fontSize={16}
            fontWeight={350}
          >
            Edit Item
          </Typography>
        </MenuItem>

        <MenuItem
          onClick={() => handleAction(() => onDelete(itemId))}
          disabled={disabled}
        >
          <ListItemIcon>
            <VyIcon icon="Delete" />
          </ListItemIcon>
          <Typography
            fontSize={16}
            fontWeight={350}
          >
            Delete Item
          </Typography>
        </MenuItem>
      </Menu>
    </div>
  );
};